function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  stroke: "#000",
  strokeWidth: 0.833,
  fillRule: "evenodd",
  strokeLinejoin: "bevel"
}, React.createElement("path", {
  d: "M5.87 8.217L1.374 26.493a.345.345 0 01-.68-.08L.542 1.43A.89.89 0 012.005.744l13.586 11.448a.345.345 0 01-.386.567L6.37 7.996a.345.345 0 00-.498.22z"
}), React.createElement("path", {
  d: "M17.756 14.016L3.104 1.67a.345.345 0 01.386-.567L26.061 13.32a.89.89 0 01-.169 1.637L9.2 19.939a.345.345 0 01-.262-.633l8.76-4.723a.345.345 0 00.06-.567z"
}), React.createElement("path", {
  d: "M6.42 20.769l20.742-6.191a.086.086 0 01.066.158L2.484 28.22a.89.89 0 01-1.29-.995l4.613-18.75a.086.086 0 01.17.021v11.943a.345.345 0 00.443.33z"
}));

var SvgFlyttaLogo = function SvgFlyttaLogo(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 29
  }, props), _ref);
};

export default __webpack_public_path__ + "97d0bcd6f784629c0b4a05cac5fe34cd.svg";
export { SvgFlyttaLogo as ReactComponent };